module.exports = __webpack_public_path__ + "static/img/vip.3077efd7.png";